import React from 'react';
import ReactDOM from 'react-dom';
import '@src/common/resetPC.css';
import './global.css';
import Container$$Page from './pages/Layout';

/* eslint-disable no-undef */
ReactDOM.render(<Container$$Page content={allData} />, document.getElementById('root'));
/* eslint-enable no-undef */
